import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';
import client from '../../apollo';
import externalOnboardingQueueQuery from '../../graphql/externalOnboardingQueueQuery';
import { toDateBound } from '../../utilities/onboardingQueue';
import { LOAD_SCOPE, QUEUE_PAGE_SIZE, QUEUE_VIEW } from '../../constants/onboardingQueue';

export const loadStarted = createAction(actionType.LOAD_STARTED);
export const viewLoaded = createAction(actionType.VIEW_LOADED);
export const viewFailed = createAction(actionType.VIEW_FAILED);
export const loadFinished = createAction(actionType.LOAD_FINISHED);
export const resetQueue = createAction(actionType.RESET);

export const BOTH_VIEWS = [QUEUE_VIEW.PENDING, QUEUE_VIEW.COMPLETED];

let requestCounter = 0;

const variablesFor = ({
  view, filters, sort, order, page,
}) => ({
  view,
  search: (filters && filters.search) || null,
  from: toDateBound(filters && filters.from),
  to: toDateBound(filters && filters.to),
  sort: sort || null,
  order: order || null,
  page: page || 0,
  size: QUEUE_PAGE_SIZE,
});

const loadView = async(dispatch, request, requestId) => {
  try {
    const { data } = await client.query({
      query: externalOnboardingQueueQuery,
      variables: variablesFor(request),
      fetchPolicy: 'network-only',
    });
    if (requestId !== requestCounter) return;
    const list = data ? data.externalOnboardingQueue : null;
    dispatch(viewLoaded({
      view: request.view,
      items: (list && list.items) || [],
      total: (list && list.total) || 0,
      refused: Boolean(data) && list === null,
    }));
  } catch (error) {
    if (requestId !== requestCounter) return;
    dispatch(viewFailed({ view: request.view, error }));
  }
};

export const loadQueue = ({ filters, viewStates }) => async dispatch => {
  requestCounter += 1;
  const requestId = requestCounter;
  dispatch(loadStarted({ filters, scope: LOAD_SCOPE.ALL }));

  await Promise.all(BOTH_VIEWS.map(view => loadView(
    dispatch,
    { ...(viewStates ? viewStates[view] : {}), view, filters },
    requestId
  )));

  if (requestId !== requestCounter) return;
  dispatch(loadFinished({ scope: LOAD_SCOPE.ALL }));
};

export const reloadView = ({
  filters, view, sort, order, page,
}) => async dispatch => {
  requestCounter += 1;
  const requestId = requestCounter;
  dispatch(loadStarted({ filters, scope: LOAD_SCOPE.VIEW }));

  await loadView(dispatch, {
    view, filters, sort, order, page,
  }, requestId);

  if (requestId !== requestCounter) return;
  dispatch(loadFinished({ scope: LOAD_SCOPE.VIEW }));
};
